export { ContainerAvatar, type ContainerAvatarProps } from '../ui/menu-item/container-avatar';
